import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ResponsiveService } from '@service/responsive.service';
import { AlarmHistoryData } from 'ops/common/models/alarm-history-data';
import { AlarmMonitoring } from 'ops/common/models/alarm-monitoring';

@Component({
    selector: 'app-alarm-history-table-row',
    templateUrl: './alarm-history-table-row.component.html',
    styleUrls: [
        './alarm-history-table-row.component.css',
        '../alarm-table-row/alarm-table-row.component.scss',
    ],
    standalone: false
})
export class AlarmHistoryTableRowComponent {
    @Input() alarm: AlarmHistoryData;

    @Output() onShowDetail = new EventEmitter<AlarmHistoryData>();

    constructor(public responsive: ResponsiveService) {}

    emitShowDetail() {
        this.onShowDetail.emit(this.alarm);
    }
}
